// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2TRA3","range":"MonthRangeSwitch_range__3bM5Y","disabled":"MonthRangeSwitch_disabled__3LkjX"};